<template>
  <div>
    <el-card class="box-card">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/goodsInfo' }">商品管理</el-breadcrumb-item>
        <el-breadcrumb-item >添加商品</el-breadcrumb-item>
      </el-breadcrumb>
    </el-card>
    <el-card class="box-card" style="margin-top: 20px;">
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品名称" prop="name">
              <el-input
                v-model="addForm.name"
                placeholder="请输入商品名称"
                auto-complete="off"
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :sm="24" :md="12" :lg="12">
          <el-form-item label="商品封面" prop="logo">
            <el-input
              type="textarea"
              v-model="addForm.logo"
              placeholder="请输入图标"
              auto-complete="off"
              maxlength="300"
            ></el-input>
          </el-form-item>
          </el-col>-->
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品封面" prop="logo">
              <div class="upload-div">
                <img class="upload-img" :src="addForm.logo?addForm.logo:defaultImg" alt />
                <div class="upload-content">
                  <div>
                    <el-upload
                      class="crm-upload"
                      :action="fileObj.url"
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      :before-upload="beforeUpload"
                      :on-success="UploadSuccess"
                      :headers="reqData"
                      list-type="picture"
                      :show-file-list="false"
                    >
                      <div class="content-text">上传封面</div>
                    </el-upload>
                  </div>
                  <div class="content-texts">
                    <span class="content-texts">建议尺寸：585*356像素，小于1MB，支持jpg、png、jpeg格式</span>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="课程属性">
              <el-checkbox v-model="addForm.recommend" true-label="1" false-label="0">是否推荐</el-checkbox>
              <el-checkbox v-model="addForm.hot" true-label="1" false-label="0">是否热门</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="是否上架" prop="sell">
              <el-radio v-model="addForm.sell" label="1">上架</el-radio>
              <el-radio v-model="addForm.sell" label="0">下架</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="有效天数" prop="validDay">
              <el-input
                type="number"
                v-model="addForm.validDay"
                placeholder="请输入有效天数"
                auto-complete="off"
                maxlength="10"
              >
                <template slot="append">天</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="标签">
              <el-input
                v-model="addForm.tags"
                placeholder="最多3个，每个不超过6个字，可空格分隔"
                auto-complete="off"
                maxlength="20"
                @input="tagsChange"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="科目课程" prop="courseId">
              <!-- <el-input
              type="number"
              v-model="addForm.courseId"
              placeholder="请输入科目id-第二级分类"
              auto-complete="off"
              maxlength="19"
              ></el-input>-->
              <el-cascader
                style="width:100%"
                clearable
                v-model="addForm.courseId"
                :show-all-levels="false"
                :props="subjectTreeProps"
                placeholder="请输入所属科目"
                :options="subjectTreeList"
                @change="subjectChange"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :sm="16" :md="7" :lg="5">
            <el-form-item label="延期天数" prop="postpone">
              <!-- <el-input
              type="number"
              v-model="addForm.postpone"
              placeholder="请输入是否支持延期"
              auto-complete="off"
              maxlength="10"
              ></el-input>-->
              <el-radio v-model="addForm.postpone" @change="postponeChange" label="1">支持</el-radio>
              <el-radio v-model="addForm.postpone" @change="postponeChange" label="0">不支持</el-radio>
            </el-form-item>
          </el-col>
          <el-col :sm="8" :md="5" :lg="3">
            <el-input
              :disabled="postDisabled"
              type="number"
              v-model="addForm.postponeDay"
              placeholder="延期天数"
              auto-complete="off"
              maxlength="10"
            >
              <template slot="append">天</template>
            </el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="主讲老师">
              <el-select
                v-model="addTeacherList"
                style="width:100%"
                multiple
                placeholder="请选择主讲老师"
                collapse-tags
                @change="teacherChange"
              >
                <el-option v-for="i in teacherList" :key="i.id" :label="i.name" :value="i.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="初始销量" prop="sellCount">
              <el-input
                type="number"
                v-model="addForm.sellCount"
                placeholder="请输入销量"
                auto-complete="off"
                maxlength="10"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="商品价格" prop="price">
              <el-input
                type="number"
                v-model="addForm.price"
                placeholder="请输入价格"
                auto-complete="off"
                maxlength="18"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="8">
            <el-form-item label="划线价格" prop="originalPrice">
              <el-input
                type="number"
                v-model="addForm.originalPrice"
                placeholder="请输入划线价格"
                auto-complete="off"
                maxlength="18"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="课程摘要">
              <el-input
                v-model="addForm.summary"
                placeholder="请输入摘要"
                auto-complete="off"
                maxlength="1000"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="24" :md="24" :lg="16">
            <el-form-item label="商品介绍" prop="detail">
              <!-- <el-input
              type="textarea"
              v-model="addForm.detailueTtext"
              placeholder="请输入详细介绍"
              auto-complete="off"
              maxlength="65535"
              ></el-input>-->
              <div style="background: #FFF">
                <UE name="1" :value="ueTtext" ref="myQuillEditorTitle"></UE>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div>
        <el-button @click="addFormBack">重置</el-button>
        <el-button type="primary" @click="addGoodsInfo">提交下一步</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import UE from "../question/CKEditor.vue";
export default {
  components: { UE },
  data() {
    return {
      postDisabled: false,
      defaultImg: "../../../static/image/defaultImg2.png",
      fileObj: {
        url: process.env.BASE_URL + "/system/uploadFile"
      },
      ueTtext: "",
      subjectTreeList: [], //科目
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children"
      },
      addTeacherList: [],
      teacherList: [],
      addForm: {
        name: "",
        logo: "",
        recommend: "",
        hot: "",
        sell: "1",
        validDay: "",
        tags: "",
        courseId: "",
        postpone: "1",
        postponeDay: "",
        sellCount: "",
        price: "",
        originalPrice: "",
        summary: "",
        detail: "",
        teacherList: []
      },
      formLabelWidth: "80px",
      addFormRules: {
        name: [
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          },
          {
            min: 1,
            max: 100,
            message: "商品名称长度在1到100个字"
          }
        ],
        teacherList: {
          required: true,
          message: "请选择主讲老师",
          trigger: "change"
        },
        // logo: [
        //   {
        //     required: true,
        //     message: "请输入图标",
        //     trigger: "blur"
        //   },
        //   {
        //     min: 1,
        //     max: 300,
        //     message: "图标长度在1到300个字"
        //   }
        // ],

        validDay: [
          {
            required: true,
            message: "请输入有效天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "有效天数格式不正确"
          }
        ],
        tags: [
          {
            required: true,
            message: "请输入标签",
            trigger: "blur"
          },
          {
            min: 1,
            max: 1000,
            message: "标签长度在1到1000个字"
          }
        ],
        courseId: [
          {
            required: true,
            message: "请选择科目课程",
            trigger: "change"
          }
        ],
        postpone: [
          {
            required: true,
            message: "请输入是否支持延期",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "是否支持延期格式不正确"
          }
        ],
        postponeDay: [
          {
            required: true,
            message: "请输入延期天数",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "延期天数格式不正确"
          }
        ],
        sellCount: [
          {
            required: true,
            message: "请输入销量",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "销量格式不正确"
          }
        ],
        price: [
          {
            required: true,
            message: "请输入价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "价格格式不正确"
          }
        ],
        originalPrice: [
          {
            required: true,
            message: "请输入原始价格",
            trigger: "blur"
          },
          {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: "原始价格格式不正确"
          }
        ],
        summary: [
          {
            required: true,
            message: "请输入摘要",
            trigger: "blur"
          },
          {
            min: 1,
            max: 1000,
            message: "摘要长度在1到1000个字"
          }
        ],
        detail: [
          {
            required: true,
            message: "请输入详细介绍",
            trigger: "blur"
          },
          {
            
            min: 1,
            max: 65535,
            message: "详细介绍长度在1到65535个字"
          }
        ]
      }
    };
  },
  methods: {
    tagsChange(){
      for(let i in this.addForm.tags.split(" ")){
        if(i>2){
          this.$message.error("最多输入三个标签，每个不超过6个字，空格分隔")
        }
        if(this.addForm.tags.split(" ")[i].length>6){
          this.$message.error("最多输入三个标签，每个不超过6个字，空格分隔")
          //this.$set(this.addForm,'tags',this.addForm.tags.split(" ")[item].substring(0,6))
        }
      }
    },
    postponeChange() {
      if (this.addForm.postpone == "1") {
        this.postDisabled = false;
      } else {
        this.postDisabled = true;
      }
    },
    teacherChange() {
      this.addForm.teacherList = [];
      for (let i in this.addTeacherList) {
        this.addForm.teacherList.push({ id: this.addTeacherList[i] });
      }
    },
    subjectChange() {
      this.addForm.courseId = this.addForm.courseId[2];
    },
    getSubjectTreeList() {
      // 获取课程
      this.api
        .getSubjectCourseTreeList()
        .then(result => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  for (let itemss of items.children) {
                    delete itemss.children;
                  }
                } else {
                  // delete items.children;
                }
              }
            } else {
              // delete item.children;
            }
          }
          this.subjectTreeList = result.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTeacherList() {
      this.api.teacher.getTeacherList().then(result => {
        this.teacherList = result.data;
      });
    },
    UploadSuccess(res, file, fileList, val) {
      console.log(res.data);
      this.addForm.logo = res.data;

      // this.picUrl.push({
      //   name: res.data[0].FileName,
      //   url: res.data[0].FilePath
      // });
    },

    handleRemove(file, fileList) {
      // this.uploadList = fileList;
      // if (this.picUrl.length > 0) {
      //   for (let i = 0; i < this.picUrl.length; i++) {
      //     if (this.picUrl[i].uid == file.uid) {
      //       this.picUrl.splice(i, 1);
      //     }
      //   }
      // }
    },
    handleChange(file, fileList) {
      // this.picUrl = fileList.slice(-1);
    },
    beforeUpload(file) {
      const isJPG = file.type.indexOf("image") > -1;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    addFormBack() {
      //this.$set(this,"addForm",{})
      (this.addForm.name = ""),
        (this.addForm.logo = ""),
        (this.addForm.recommend = ""),
        (this.addForm.hot = ""),
        (this.addForm.sell = "1"),
        (this.addForm.validDay = ""),
        (this.addForm.tags = ""),
        (this.addForm.courseId = ""),
        (this.addForm.postpone = "1"),
        (this.addForm.postponeDay = ""),
        (this.addForm.sellCount = ""),
        (this.addForm.price = ""),
        (this.addForm.originalPrice = ""),
        (this.addForm.summary = ""),
        (this.addForm.detail = ""),
        (this.addForm.teacherList = []),
        (this.addTeacherList = []);
      //this.$router.push({ path: "/goodsInfo" });
    },
    addGoodsInfo() {
      if (this.$refs.myQuillEditorTitle._data.content) {
        this.addForm.detail = this.$refs.myQuillEditorTitle._data.content;
        this.$refs.addForm.validate(valid => {
          if (valid) {
            addForm.detailueTtext;
            this.api.goodsInfo
              .addGoodsInfo(this.addForm)
              .then(result => {
                console.log(result);
                if (result.success) {
                  this.$router.push({
                    path: "/goodsInfo/goodsItem",
                    query: { updatePageGoodsItem: result.data }
                  });
                }
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            return false;
          }
        });
      } else {
        this.$message.error("商品介绍不能为空");
      }
    }
  },
  computed: {
    reqData() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.getSubjectTreeList();
    this.getTeacherList();
  }
};
</script>
<style lang="less" scoped>
.list-name-img {
  display: flex;
  flex-direction: row;
  align-items: center;
  img {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    margin-right: 10px;
  }
}
.upload-div {
  display: flex;
  flex-direction: row;
  .upload-img {
    width: 160px;
    height: 100px;
    border-radius: 4px;
    border: 1px solid rgb(238, 238, 238);
  }
  .upload-content {
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content-text {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      border: 1px solid rgb(77, 148, 255);
      color: rgb(77, 148, 255);
      font-size: 12px;
    }
    .content-texts {
      color: rgb(162, 170, 188);
      font-size: 12px;
      white-space: nowrap;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/goodsInfo/addGoods.vue